import React, { useEffect, useState } from 'react';
import api from '@/lib/api';
import { PageHeader } from '@/components/app/PageHeader';
import { Card } from '@/components/ui/card';
import { formatINR, fmtDate } from '@/lib/format';
import { StatusPill } from '@/components/app/StatusPill';

export default function LeaseExpiry() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get('/reports/lease-expiry', { params: { days: 365 } }).then(r => setItems(r.data)); }, []);
  return (
    <div>
      <PageHeader title="Lease expiry" subtitle="Renewals due in the next 12 months" />
      <Card className="p-0 overflow-x-auto">
        <table className="w-full min-w-[640px] text-sm">
          <thead className="bg-muted/60">
            <tr>
              <th className="text-left px-3 py-2 text-xs uppercase text-muted-foreground">Agreement</th>
              <th className="text-left px-3 py-2 text-xs uppercase text-muted-foreground">Tenant</th>
              <th className="text-left px-3 py-2 text-xs uppercase text-muted-foreground">Property / Unit</th>
              <th className="text-left px-3 py-2 text-xs uppercase text-muted-foreground">End date</th>
              <th className="text-right px-3 py-2 text-xs uppercase text-muted-foreground">Rent</th>
              <th className="text-right px-3 py-2 text-xs uppercase text-muted-foreground">Days left</th>
              <th className="text-left px-3 py-2 text-xs uppercase text-muted-foreground">Status</th>
            </tr>
          </thead>
          <tbody>
            {items.map((l) => (
              <tr key={l.id} className="border-t hover:bg-muted/40">
                <td className="px-3 py-2 font-mono">{l.agreement_number}</td>
                <td className="px-3 py-2">{l.tenant_name}</td>
                <td className="px-3 py-2">{l.property_name} <span className="text-muted-foreground">/</span> {l.unit_number}</td>
                <td className="px-3 py-2">{fmtDate(l.end_date)}</td>
                <td className="px-3 py-2 text-right tabular-nums">{formatINR(l.rent_amount)}</td>
                <td className="px-3 py-2 text-right tabular-nums">{l.days_to_expiry}</td>
                <td className="px-3 py-2"><StatusPill status={l.status} /></td>
              </tr>
            ))}
            {!items.length && <tr><td colSpan={7} className="text-center text-muted-foreground py-8">No leases expiring soon.</td></tr>}
          </tbody>
        </table>
      </Card>
    </div>
  );
}
